import React from 'react'


export default function Duration({ className, seconds, frmt }) {
  if (typeof frmt === "undefined" || Number.isNaN(frmt)) {
    return (
      <time dateTime={`P${Math.round(seconds)}S`} className={className}>
        {toHHMMSS(seconds)}
      </time>
    )
  } else {
    return (
      <div>
        {toHHMMSS(seconds)}
      </div>
    )
  }
}

const toHHMMSS = (sec = 0) => { //https://stackoverflow.com/questions/6312993/javascript-seconds-to-time-string-with-format-hhmmss
  var date = new Date(null);
  date.setSeconds(sec); // specify value for SECONDS here
  return date.toISOString().substr(11, 8);
}


// WEBPACK FOOTER //
// ./src/components/Duration.jsx